module.exports = __webpack_public_path__ + "img/grey-right.21ed9411.svg";